const DROPOFF_TIME_OPTIONS = {
  FASTEST: 'DROPOFF_TIME_FASTEST',
  SAMEDAY_6PM: 'DROPOFF_TIME_6PM',
  SAMEDAY_AFTER_6PM: 'DROPOFF_TIME_AFTER_6PM',
  INSTANT_DELIVERY: 'DROPOFF_TIME_INSTANT_DELIVERY',
}

const DELIVERY_QUOTATION_TYPES = {
  INSTANT: 'instant',
  SPEED: 'speed',
  SAMEDAY_DAY: 'same_day_day',
  SAMEDAY_NIGHT: 'same_day_night',
}

export { DROPOFF_TIME_OPTIONS, DELIVERY_QUOTATION_TYPES }
